export const listOfZones = [
        {name: 'UTC+2', offset: -120, offsetTime: '+02:00'},
        {name: 'UTC+1', offset: -60, offsetTime: '+01:00'},
        {name: 'UTC', offset: 0, offsetTime: '+00:00'},
        {name: 'UTC-1', offset: 60, offsetTime: '-01:00'},
        {name: 'UTC-2', offset: 120, offsetTime: '-02:00'},
    ]
